import React, { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";
import { dapi as api } from "./deskApi";

const SEEN_KEY = "artcraft_seen_versions";

// Small desktop note listing programs that the monthly update moved to a new version.
export const ArtCraftUpdateNotice = () => {
  const [updates, setUpdates] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get("/artcraft/apps").then(({ data }) => {
      if (!alive) return;
      let seen = null;
      try { seen = JSON.parse(localStorage.getItem(SEEN_KEY) || "null"); } catch { seen = null; }
      const current = Object.fromEntries(data.filter((a) => a.version).map((a) => [a.key, a.version]));
      if (!seen) {
        // First visit on this browser: remember versions, only mention updates from the last 7 days.
        localStorage.setItem(SEEN_KEY, JSON.stringify(current));
        const recent = Date.now() - 7 * 864e5;
        setUpdates(data.filter((a) => a.version && a.updated_at && Date.parse(a.updated_at) > recent));
        return;
      }
      setUpdates(data.filter((a) => a.version && seen[a.key] && seen[a.key] !== a.version));
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  const dismiss = () => {
    setUpdates((list) => {
      let seen = {};
      try { seen = JSON.parse(localStorage.getItem(SEEN_KEY) || "{}") || {}; } catch { seen = {}; }
      localStorage.setItem(SEEN_KEY, JSON.stringify({ ...seen, ...Object.fromEntries(list.map((a) => [a.key, a.version])) }));
      return [];
    });
  };
  if (!updates.length) return null;
  return (
    <div className="absolute right-3 bottom-14 z-[60] w-72 rounded-lg bg-slate-900/90 backdrop-blur text-white shadow-2xl p-3" data-testid="artcraft-update-notice">
      <div className="flex items-start gap-2">
        <Sparkles className="w-4 h-4 mt-0.5 text-amber-300 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold">Programs updated</div>
          <ul className="mt-1 space-y-0.5 text-xs text-slate-200">
            {updates.map((a) => (
              <li key={a.key} data-testid={`artcraft-update-${a.key}`}>
                {a.title} {a.previous_version ? <>{a.previous_version} → </> : "to "}<b>{a.version}</b>
              </li>
            ))}
          </ul>
        </div>
        <button type="button" onClick={dismiss} className="p-0.5 rounded hover:bg-white/10" aria-label="Dismiss" data-testid="artcraft-update-dismiss"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};
